module.exports = __webpack_public_path__ + "static/media/vitaldetails2.acaf5823.png";